/* eslint-disable */
import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { connect } from 'react-redux';
import { ModalRoute } from 'react-router-modal';
import qs from 'querystring';

import { flattenBookingsToJobs } from '../../../api/DataHandlers';
import { executeHttpRequest } from '../../../epics/api';

import BookingStartTimeWidget from '../../operations/bookings/BookingStartTimeWidget';
import BookingEndTimeWidget from '../../operations/bookings/BookingEndTimeWidget';
import ConflictTimesContainer from '../../operations/bookings/conflictTimesContainer';

import history from '../../../history';

class PayrollSubComponent extends Component {
    constructor(props) {
        super(props);
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.state = {
            loading: false,
            content: [],
            meta: {},
            currentPage: 0,
            query: {
                page: 1,
                before: currentUrlParams.get('bookings_before') || '',
                after: currentUrlParams.get('bookings_after') || '',
            },
        };
        if (currentUrlParams.get('bookings_client')) {
            this.state.query.bookings_client =
                currentUrlParams.get('bookings_client');
        }
    }

    componentDidMount() {
        this.props.setRef(this);
        this.getData(qs.stringify(this.state.query));
        this.row ? this.row.scrollIntoView({ behavior: 'smooth' }) : null;
    }

    componentWillUnmount() {
        this.props.setRef(null);
    }

    reloadSubData = () => {
        this.getData(qs.stringify(this.state.query));
    };

    getData = queryString => {
        const { worker } = this.props;
        const { currentPage } = this.state;
        this.setState({ loading: true });
        return executeHttpRequest(
            `jobs/?freelancer_id=${worker.id}&${queryString}`,
        ).then(response => {
            const flatData = flattenBookingsToJobs(response.data);
            const cloneContent = [...flatData.content];
            let newContent = cloneContent;
            if (flatData.content.length > 10) {
                const firstHalf = cloneContent.splice(0, 10);
                if (currentPage % 2 == 0) {
                    newContent = firstHalf;
                }
            }
            this.setState({
                meta: flatData.meta,
                content: newContent,
                loading: false,
            });
        });
    };

    getNoDataProps = (state, rowInfo, column, instance) => ({
        onClick: e => {
            this.props.onRowCollapse(this.props.id);
        },
    });

    getProps = (state, rowInfo, column, instance) => ({
        style: {
            background: 'transparent',
        },
    });

    getTrProps = (state, rowInfo, column, instance) => ({
        style: {
            background: 'transparent',
        },
    });

    getTdProps = () => ({
        style: {
            lineHeight: '45px',
        },
    });

    onPageChange = pageIndex => {
        const pageToFetch = Math.floor(pageIndex / 2) + 1;
        this.setState({ currentPage: pageIndex });
        this.setState(
            {
                query: {
                    ...this.state.query,
                    page: pageToFetch,
                },
            },
            () => {
                this.getData(qs.stringify(this.state.query));
            },
        );
    };

    render() {
        const columns = [
            {
                id: 'ref',
                Header: () => <span ref={el => (this.row = el)}>Ref</span>,
                accessor: row => row.booking.reference_number,
                headerStyle: { paddingLeft: '19px' },
                width: 110,
                style: { paddingLeft: '19px' },
                Cell: row => (
                    <a
                        className="group-link"
                        href={`/operations/bookings?page=1&getall=1&search=${row.value}`}
                    >
                        {row.value}
                    </a>
                ),
            },
            {
                id: 'clientName',
                Header: 'Client',
                accessor: row => row.client_full.company_name,
                width: 150,
            },
            {
                Header: 'Date',
                accessor: 'date',
                maxWidth: 80,
                Cell: row => {
                    const date = moment(row.value).format('DD/MM/YYYY');
                    return date;
                },
            },
            {
                id: 'startTime',
                Header: 'Start Time',
                headerStyle: { paddingLeft: '6px' },
                width: 110,
                sortable: false,
                accessor: row => row.booking.clock_in || '',
                Cell: row => (
                    <div className="summary-clockin">
                        <div className="start-time__row">
                            <BookingStartTimeWidget
                                job={row.original}
                                notification={this.props.notification}
                                history={history}
                                table={this.props.table}
                                enableModal={true}
                                enableLinkToModal={true}
                                isPreviewMode={false}
                            />
                        </div>
                    </div>
                ),
            },
            {
                id: 'endTime',
                Header: 'End Time',
                headerStyle: { paddingLeft: '6px' },
                width: 110,
                sortable: false,
                accessor: row => row.booking.clock_out || '',
                Cell: row => {
                    const { isClient } = this.props.user;
                    return (
                        <div className="summary-clockout">
                            <ModalRoute
                                id={row.original.booking.id}
                                path={`${this.props.match.path}/clockin-out/${row.original.booking.id}`}
                                component={ConflictTimesContainer}
                                linkClassName="clock-link"
                                className={
                                    isClient
                                        ? 'react-router-modal__modal clock-out-client'
                                        : 'react-router-modal__modal'
                                }
                                props={{
                                    job: row.original,
                                    notification: this.props.notification,
                                    isClient,
                                    table: this.props.table,
                                    history,
                                    reloadData: () =>
                                        this.getData(
                                            qs.stringify(this.state.query),
                                        ),
                                    mode: 'payroll',
                                }}
                                onBackdropClick={() => {
                                    const { id } = row.original.booking;
                                    const pathname =
                                        this.props.location.pathname.replace(
                                            `clockin-out/${id}`,
                                            '',
                                        );
                                    history.push(
                                        pathname + this.props.location.search,
                                    );
                                }}
                            />
                            <div className="end-time__row">
                                <BookingEndTimeWidget
                                    job={row.original}
                                    notification={this.props.notification}
                                    history={history}
                                    table={this.props.table}
                                    enableModal={false}
                                    enableLinkToModal={true}
                                    isPreviewMode={false}
                                />
                            </div>
                        </div>
                    );
                },
            },
            {
                Header: 'Duration',
                accessor: 'duration',
                width: 90,
                Cell: row => {
                    const { booking } = row.original;
                    const startTime = moment(
                        booking.datetime_started || row.original.start_datetime,
                    );
                    const finishTime = moment(
                        booking.datetime_finished || row.original.end_datetime,
                    );
                    const duration = finishTime.diff(startTime, 'hours', true);
                    return (
                        <span>{parseFloat(duration.toFixed(2)) || '-'}</span>
                    );
                },
            },
            {
                id: 'hourlyRate',
                Header: 'Hourly Rate',
                accessor: row => row.booking.freelancer_pay_per_hour,
                width: 110,
                HeaderStyle: { paddingRight: '24px' },
                Cell: row =>
                    row.value > 0 ? <span>£{row.value.toFixed(2)}</span> : '-',
            },
            {
                id: 'shiftPay',
                Header: 'Shift Pay',
                accessor: row => row.booking.freelancer_total_pay,
                width: 110,
                Cell: row =>
                    row.value > 0 ? <span>£{row.value.toFixed(2)}</span> : '-',
            },
            {
                id: 'shiftBreak',
                Header: 'Break (in min)',
                accessor: row => row.booking.breaks,
                width: 110,
                Cell: row =>
                    row.value > 0 ? <span>{row.value}</span> : '-',
            },
        ];

        const { content, meta, currentPage, loading } = this.state;

        let hasPagination = false;
        let pageSize = 0;
        let pages = -1;
        if (content && meta) {
            pages = Math.ceil(meta.count / 10);
            pageSize = content.length;
            if (meta.count > 10) {
                hasPagination = true;
            }
        }
        return (
            <div className="payroll-subcomponent">
                <ReactTable
                    data={content}
                    columns={columns}
                    showPageSizeOptions={false}
                    showPaginationBottom={hasPagination}
                    page={currentPage}
                    pageSize={pageSize}
                    pages={pages}
                    loading={loading}
                    getProps={this.getProps}
                    getTrProps={this.getTrProps}
                    getTdProps={this.getTdProps}
                    getNoDataProps={this.getNoDataProps}
                    onPageChange={this.onPageChange}
                    manual={true}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(PayrollSubComponent);
